module.exports = __webpack_public_path__ + "media/TAMA_Sommerquiz_26_9x16_komprimiert.6fcf6b70.mp4";